module.exports = __webpack_public_path__ + "img/1-1ZF31555342D.fe62607a.jpg";